import React from 'react'
import { FormGroup, FormControl } from 'react-bootstrap'
import { find } from 'lodash'
import { replaceExpression, isEmptyValue } from '../utils'
import CheckmarkQuestionAnswered from './CheckmarkQuestionAnswered'

export default class TextQuestion extends React.Component {
  
  getValue(optionId) {
    const value = find(this.props.state, s => s.optionId === optionId)
    return value && value.stringValue
  }

  obtainAnsweredCheckDOM(optionIds) {
    let questionHasAnswer = true

    optionIds.forEach(id => {
      const value = this.getValue(id)
      if (isEmptyValue(value)) questionHasAnswer = false
    })
  
    return (
      <CheckmarkQuestionAnswered checked={questionHasAnswer} />
    )
  }

  render() {
    const { data, completed, onChange, answermap } = this.props
    const optionIds = data.options.map(option => option.id)

    return (
      <div className="question-group type-text row">
        <div className="col">
          <form>
            <span>
              {replaceExpression(data.questionText, answermap)}
              <div className="indicator-container">
                {this.obtainAnsweredCheckDOM(optionIds)}
              </div>
            </span>
            <FormGroup controlId="formControlsTextarea">
              {data.options.map(option => (
                <FormControl
                  componentClass="textarea"
                  key={option.id}
                  disabled={completed}
                  value={this.getValue(option.id)}
                  onChange={e => onChange(e, option.id, false)}
                  onBlur={e => onChange(e, option.id, true)}
                />
              ))}
            </FormGroup>
          </form>
        </div>
        <div className="col"></div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/TextQuestion.js